import React from "react";
import "./CandidateInfoHeader.css";
import { FiUser, FiMail, FiEye, FiEyeOff, FiCopy, FiArrowLeft } from "react-icons/fi";

function CandidateInfoHeader({
  name,
  email,
  maskedJwt,
  onToggle,
  onCopy,
  isVisible

}) {
  return (
    <div className="candidate-info-header">
      <div className="cih-container">

        {/* LEFT SIDE */}
        <div className="cih-left">
          <div className="cih-row">
            <FiUser className="cih-icon" />
            <span className="cih-name">{name}</span>
          </div>

          <div className="cih-row">
            <FiMail className="cih-icon" />
            <span className="cih-email">{email}</span>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="cih-right">

          <span className="cih-jwt-label">Resume Generator Key:</span>

          <div className="cih-jwt-box">
            <span className="cih-jwt-text">{maskedJwt}</span>

            <div className="cih-jwt-actions">
              <span className="cih-action-btn" onClick={onToggle}>
                {isVisible ? <FiEyeOff /> : <FiEye />}
              </span>

              <span className="cih-action-btn" onClick={onCopy}>
                <FiCopy />
              </span>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}

export default CandidateInfoHeader;
